export default function plural(input, count = 1) {
    if (count > 1) {
        return input + "s";
    } else {
        return input;
    }
}
